import React, { PureComponent } from "react";
import { Image } from ".";
import logo from "../assets/images/logo-kkc.png";
import logoWhite from "../assets/images/logo-kkc-white.png";

export default class Logo extends PureComponent {
  render() {
    const { color } = this.props;
    return (
      <Image
        className="logo-component"
        src={color === "white" ? logoWhite : logo}
        alt={process.env.REACT_APP_WEBSITE_NAME}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Logo.js